<template>
	<div class="dropProvice flex-column" v-if="begin_ToTab !== null">
		<div class="header itemCenter space-between">
			<i class="fa fa-angle-left" @click="closePick" ></i>
			<!--<i class="iconfont icon-iconfontjiantou1" @click="dropProvice"></i>-->
			<span>选择地址</span>
		</div>

		<div class="lc_cityTab flex-column-1 flex-column">
			<ul class="cityTab_list flex">
				<li :class="{'active': proTab == 1}" @click="changeList(1)">省</li>
				<li :class="{'active': proTab == 2}" @click="changeList(2)">市</li>
				<li v-if="chooseArea" :class="{'active': proTab == 3}" @click="changeList(3)">区</li>
			</ul>

			<ul class="lc_proList flex fwrap">
				<li v-if="proTab == 1" v-for="(pro,idx) in proList" class="flex itemCenter fCenter" @click="selectPro(pro.value,pro.text,idx)" :class="{'active': proviceTab === idx}">{{pro.text}}</li>

				<li v-if="proTab == 2 && hasPro == 1" v-for="(city,idx) in cityList" class="flex itemCenter fCenter" @click="selectcity(city.value,city.text,idx)" :class="{'active': cityTab === idx}">{{city.text}}</li>
				<li v-if="proTab == 3" v-for="(area,idx) in areaList" class="flex itemCenter fCenter" @click="selectArea(area.value,area.text,idx)" :class="{'active': areaTab === idx}">{{area.text}}</li>
			</ul>
		</div>

	</div>
</template>

<script>
import { CITY } from "@/assets/configs"
import { Header } from 'mint-ui';

export default {
	props:["chooseArea"],
	data () {
		return{
			begin_ToTab : true,
			proTab: 1,
			proviceTab: null,
			cityTab: null,
			areaTab:null,
			proList: [], //省份列表
			cityList: [], //城市列表
			areaList: [],
			proValue:null,
			proText:null,
			cityValue:null,
			cityText:null,
			areaText:null,
			areaText:null,
		}
	},
	methods : {
		closePick () {
			this.$emit("closePick")
		},
		dropProvice() {
			this.begin_ToTab = null;
		},
		/*切换省份和城市*/
		changeList(idx) {
			this.proTab = idx;
			if(idx == 1){
				this.cityTab = null
				this.areaTab = null
				this.cityValue = null
				this.cityText = null
				this.areaValue = null
				this.areaText = null
			}
			if(idx == 2) {
				this.areaValue = null
				this.areaText = null
				this.areaTab = null
				if(this.hasPro == 0) {
					mui.toast('请先选择省份')
				}
			}
		},
		/*根据选择的省份获取省份的城市*/
		selectPro(value,text,idx) {
			this.proValue = value
			this.proText = text
			this.proviceTab = idx;
			this.areaList = [];
			for(var i = 0; i < this.proList.length; i++) {
				if(this.proList[i].value == value) {
					this.cityList = this.proList[i].children;
					this.hasPro = 1;
					this.proTab = 2;
				}
			}
			if(text == "全部"){
				this.cityValue = ""
				this.cityText = "全部"
				this.emitSelected()
			}
		},
		/*选择的城市*/
		selectcity(value, text, idx) {
			this.cityValue = value
			this.cityText = text
			this.cityTab = idx
			if(this.chooseArea){
				for(var i = 0; i < this.cityList.length; i++) {
					if(this.cityList[i].value == value) {
						this.areaList = this.cityList[i].children;
						this.proTab = 3;
					}
				}
			}else{
				this.emitSelected()
			}
		},
		//选择区域
		selectArea (value, text, idx) {
			this.areaTab = idx
			this.areaValue = value
			this.areaText = text
			this.emitSelected()
		},
		emitSelected(){
			const obj = {
				provinceValue:this.proValue,
				provinceText:this.proText,
				cityValue:this.cityValue,
				cityText:this.cityText,
				areaValue:this.areaValue,
				areaText:this.areaText
			}
			this.$emit("emitCity",obj)
		}
	},
	mounted () {
		this.proList = CITY
	}
}
</script>


<style lang="scss" scoped>
	.dropProvice {
		font-size:14px;
	    position: fixed;
	    width: 100%;
	    height: 100%;
	    top: 0;
	    left: 0;
	    z-index: 100;
	    background-color: #FFFFFF;
    .header {
        width: 100%;
        height: 1.5rem;
        text-align: center;
        line-height: 1.5rem;
        padding-left: 0.47rem;
        box-sizing: border-box;
        position:relative;
        span {
            font-size: 0.56rem;
            color: #333333;
        }
        .iconfont {
            font-size: 0.62rem;
            color: #666666;
        }
        .fa-angle-left{
	    	font-size:0.8rem;
	    	position: absolute;
	    	left:0.4rem;
	    	top:0.3rem;
	    }
    }
    .lc_cityTab {
        .cityTab_list {
        	width:100%;
        	height:1.25rem;
	        border-bottom: 0.06rem solid #05BC6A;
	        padding-top:0.2rem;
	        margin-bottom:0;
	        li {
	            width: 2.6rem;
	            height: 1.0rem;
	            text-align: center;
	            line-height: 1.0rem;
	            font-size: 14px;
	            float:left;
	            background: #E6F9F1;
	            color: #838985;
	            border-radius: 0.12rem 0.12rem 0 0;
	            margin-left: 0.28rem
	        }
	        .active {
	            color: #FFFFFF;
	            background: #4BB895;
	        }
        }
        .lc_proList {
        	display: flex;
        	flex-wrap:wrap;
            li {
            	display: flex;
            	justify-content:center;
            	align-items:center;
	            width: 2.3rem;
	    		padding: 0.2rem 0.2rem;
	            line-height: 0.8rem;
	            text-align: center;
	            font-size: 14px;
	            color: #070707;
	            background: #F7F8F7;
	            border-radius: 0.12rem;
	            margin: 0.1rem;
            }
            .active {
	            color: #FFFFFF;
	            background: #4BB895;
            }
        }
    }
}
</style>